var SVGPanZoomUtil = (function() {
    var _panZoom;
    var _eventsHandler;
    var _svgId;
    var _isMobile;
    var _defaultOptions = {
        dblClickZoomEnabled: false,
        customEventsHandler: _eventsHandler,
        zoomScaleSensitivity: 0.05,
        minZoom: 0.67,
        maxZoom: 8
    };

    function createEventsHandler(){
        return {
            haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
            init: function(options) {
                var instance = options.instance;
                var initialScale = 1;
                var pannedX = 0;
                var pannedY = 0;

                // Init Hammer
                // Listen only for pointer and touch events
                this.hammer = Hammer(options.svgElement, {
                    prevent_default: false,
                    inputClass: Hammer.SUPPORT_POINTER_EVENTS ? Hammer.PointerEventInput : Hammer.TouchInput
                });

                // Enable pinch
                this.hammer.get('pinch').set({enable: true});

                // Handle pan
                this.hammer.on('pan panstart panend', function(event){
                    // On pan start reset panned variables
                    if (event.type === 'panstart') {
                        pannedX = 0;
                        pannedY = 0;
                    }

                    // Pan only the difference
                    if (event.type === 'pan' || event.type === 'panend') {
                        instance.panBy({x: event.deltaX - pannedX, y: event.deltaY - pannedY});
                        pannedX = event.deltaX;
                        pannedY = event.deltaY;
                    }
                });

                // Handle pinch
                this.hammer.on('pinch pinchstart pinchend', function(event){
                    // On pinch start remember initial zoom
                    if (event.type === 'pinchstart') {
                        initialScale = instance.getZoom();
                        instance.zoom(initialScale * event.scale);
                    }

                    // On pinch zoom
                    if (event.type === 'pinch' || event.type === 'pinchend') {
                        instance.zoom(initialScale * event.scale);
                    }
                });

                // Prevent moving the page on some devices when panning over SVG
                options.svgElement.addEventListener('touchmove', function(event){
                    event.preventDefault();
                });
            },
            destroy: function(){
                this.hammer.destroy();
            }
        };
    }

    function panUp(){
        _panZoom.panBy({x: 0, y: 50});
    }

    function panDown(){
        _panZoom.panBy({x: 0, y: -50});
    }

    function panLeft(){
        _panZoom.panBy({x: 50, y: 0});
    }

    function panRight(){
        _panZoom.panBy({x: -50, y: 0});
    }

    function zoomOut(){
        _panZoom.zoomOut();
    }

    function zoomIn(){
        _panZoom.zoomIn();
    }

    function createNSElement(elementType) {
        return $(document.createElementNS('http://www.w3.org/2000/svg', elementType));
    }

    function setupCompass() {
        if ( $('#chart svg:first .compass').length || !$('#chart').is(':visible') ){
            return;
        }

        var $compass = createNSElement('g');
        $compass.attr('class', 'compass');
        $('#' + _svgId).append( $compass );

        if (!_isMobile){
            $compass.append(createNSElement('path')
                .attr({'class': 'left-arrow', 'fill': '#FFFFFF', 'clip-rule': 'evenodd', 'fill-rule': 'evenodd', 'd': 'M34.2,38.2L14.3,18.4c-11,11-11,28.8,0,39.7L34.2,38.2z'})
                .click(panLeft)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'up-arrow', 'fill': '#FFFFFF', 'clip-rule': 'evenodd', 'fill-rule': 'evenodd', 'd': 'M34.2,38.2l19.9-19.9c-11-11-28.8-11-39.7,0L34.2,38.2z'})
                .click(panUp)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'down-arrow', 'fill': '#FFFFFF', 'clip-rule': 'evenodd', 'fill-rule': 'evenodd', 'd': 'M34.2,38.2l19.9,19.9c-11,11-28.8,11-39.7,0L34.2,38.2z'})
                .click(panDown)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'right-arrow', 'fill': '#FFFFFF', 'clip-rule': 'evenodd', 'fill-rule': 'evenodd', 'd': 'M34.2,38.2l19.9-19.9c11,11,11,28.8,0,39.7L34.2,38.2z'})
                .click(panRight)
            );

            $compass.append(createNSElement('polygon')
                .attr({'class': 'right-arrow', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#555555', 'points': '57.4,38.1 51.3,32 50,33.4 54.9,38.2 50.1,42.9 51.3,44.1' })
                .click(panRight)
            );

            $compass.append(createNSElement('polygon')
                .attr({'class': 'left-arrow', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#555555', 'points': '10.2,38.1 16.2,32 17.5,33.4 12.7,38.2 17.4,42.9 16.2,44.1' })
                .click(panLeft)
            );

            $compass.append(createNSElement('polygon')
                .attr({'class': 'down-arrow', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#555555', 'points': '34.3,61.1 39.9,55 38.7,53.9 34.2,58.6 29.8,53.9 28.6,55 ' })
                .click(panDown)
            );

            $compass.append(createNSElement('polygon')
                .attr({'class': 'up-arrow', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#555555', 'points': '34.3,15 39.9,21.1 38.7,22.3 34.2,17.5 29.8,22.2 28.6,21.1' })
                .click(panUp)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'zoom-in', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#FFFFFF', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': 10, 'd': 'M20.7,71.1c0-2.5,1.6-4,4.2-4h18.2c2.6,0,4.2,1.5,4.2,4v17.6c0,2.5-1.6,4-4.2,4H24.8c-2.6,0-4.2-1.5-4.2-4 L20.7,71.1L20.7,71.1z'})
                .click(zoomIn)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'zoom-out', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#FFFFFF', 'stroke-linecap': 'round', 'stroke-linejoin': 'round', 'stroke-miterlimit': 10, 'd': 'M20.7,97.2c0-2.5,1.6-4,4.2-4h18.2c2.6,0,4.2,1.5,4.2,4v17.6c0,2.5-1.6,4-4.2,4H24.8c-2.6,0-4.2-1.5-4.2-4 L20.7,97.2L20.7,97.2z'})
                .click(zoomOut)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'zoom-in', 'fill': '#545454', 'd': 'M34.9,74.5V79h4.3v1.9h-4.3v4.5h-2v-4.5h-4.3v-2h4.3v-4.5h1.9v0.1H34.9z'})
                .click(zoomIn)
            );

            $compass.append(createNSElement('path')
                .attr({'class': 'zoom-out', 'fill': '#545454', 'd': 'M38.5,105.1v1.9h-9v-1.9H38.5z'})
                .click(zoomOut)
            );

            $compass.append(createNSElement('polygon')
                .attr({'class': 'home-button', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#555555', 'points': '33.9,27.6 27.6,33.8 27.5,33.8 27.5,33.9 22.8,38.4 23,38.6 27.2,38.6 27.2,46.9 31.3,46.9 31.3,41.6 36.4,41.6 36.4,46.9 40.5,46.9 40.5,38.6 45,38.6 44.9,38.4 40.2,33.9 40.2,33.8 40.1,33.8' })
                .click(function(event){
                    event.stopPropagation();
                    event.preventDefault();
                    FG.Event.setResetToStepOne();
                })
            );
        } else {
            // Only home button on mobile, not arrows etc
            $compass.append(createNSElement('circle')
                .attr({'class': 'home-button', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#FFFFFF', 'stroke': '#999999', 'stroke-width': '0.5', 'stroke-linejoin': 'round', 'stroke-linecap': 'round', 'stroke-miterlimit': '10', 'cx': '34', 'cy': '37.7', 'r': '20.5' })
                .click(function(event){
                    event.stopPropagation();
                    event.preventDefault();
                    FG.Event.setResetToStepOne();
                })
            );

            $compass.append(createNSElement('polygon')
                .attr({'class': 'home-button', 'fill-rule': 'evenodd', 'clip-rule': 'evenodd', 'fill': '#555555', 'points': '34,27.1 27.7,33.3 27.6,33.3 27.6,33.4 22.9,37.9 23.1,38.1 27.3,38.1 27.3,46.4 31.4,46.4 31.4,41.1 36.5,41.1 36.5,46.4 40.6,46.4 40.6,38.1 45.1,38.1 45,37.9 40.3,33.4 40.3,33.3 40.2,33.3'})
                .click(function(event){
                    event.stopPropagation();
                    event.preventDefault();
                    FG.Event.setResetToStepOne();
                })
            );

            $('.home-button').each(function() {
                Hammer(this).on('tap', function() {
                    FG.Event.setResetToStepOne();
                });
            });
        }
    }

    function initSvgPanZoom(isMobileJS) {
        _svgId = $('#chart svg:first').attr('id');
        _eventsHandler = _eventsHandler || createEventsHandler();
        _defaultOptions.customEventsHandler = _eventsHandler;
        _isMobile = isMobileJS;

        if (_panZoom) {
            _panZoom.destroy();
        }

        _panZoom = svgPanZoom('#' + _svgId, _defaultOptions);

        // For iPhone 5 issue about svgPanZoom not activating actual SVG
        setTimeout(function() {
            _panZoom.destroy();
            _panZoom = svgPanZoom('#' + _svgId, _defaultOptions);
        }, 1);

        setupCompass();
    }


    return {
        init: initSvgPanZoom
    };
}());
